import { createContext } from "react";

export const SearchIndexContext = createContext({
  eventsSearchIndex: null,
});

export default SearchIndexContext;
